// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Download = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.953 3.645C19.747 3.645 22 6.023 22 8.947c0 2.924-2.254 5.303-5.047 5.303H4.388C1.958 14.25 0 12.183 0 9.643c0-2.46 1.838-4.479 4.161-4.603C5.02 2.083 7.621 0 10.63 0c2.488 0 4.727 1.43 5.91 3.662.137-.012.275-.017.414-.017Zm-1.145.768c-.972-2.08-2.964-3.419-5.179-3.419-2.667 0-4.973 1.939-5.606 4.658a.495.495 0 0 1-.497.384c-.027 0-.05-.002-.086-.005C2.516 6.028.988 7.641.988 9.643c0 2.001 1.528 3.613 3.4 3.613h12.565c2.236 0 4.059-1.924 4.059-4.31 0-2.385-1.822-4.307-4.059-4.307-.189 0-.375.013-.56.04a.483.483 0 0 1-.585-.266Zm-5.38 1.029v3.796L9.363 8.165a.569.569 0 0 0-.807 0 .577.577 0 0 0 0 .812l2.04 2.054a.57.57 0 0 0 .824-.016l2.026-2.038a.577.577 0 0 0 0-.812.569.569 0 0 0-.807 0L11.57 9.237V5.442A.573.573 0 0 0 11 4.867a.573.573 0 0 0-.571.575Z"
			fill="#4A90E2"
		/>
	</svg>
);
export default Download;
